export default __webpack_public_path__ + "static/media/sampleImg.2fb01b4f.png";